// ----------------------------
// Created by Bulletproof Games
//            2021
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Game

game = {};
gameData = {};
gameData.gameName = 'Sidewinder';
gameData.gameVersionMajor = '1';
gameData.gameVersionMinor = '0';
gameData.gameVersionBugFix = '0';
gameData.gameReleaseDate = '22/06/2026'; // update me upon release
gameData.version = '' + gameData.gameVersionMajor + '.' + gameData.gameVersionMinor + '.' + gameData.gameVersionBugFix;

gameData.symbolWidth = 166;
gameData.symbolHeight = 162;
gameData.appertureSize = 173;
gameData.numReels = 5;
gameData.numRows = 3;

game.sideMenuOpen = false;
let _timeScale = 1;
let _backgroundLightning = undefined;

// Splash screen panel management
let _splashScreenPanelSwapping = false;
let _currentSplashScreenPanelIndex = 0;
const _splashScreenPanelContents = [];
let _splashScreenArrowLeft = null;
let _splashScreenArrowRight = null;
let _splashScreenAutoSwapPanelTimeline = null;
let _splashScreenMask = null;
let _gameAlreadyLoaded = false;

game.enableSpeedUp = function () {
  const caller = new Error().stack?.split('\n')[2]?.trim().split(' ')[1];
  if (caller === 'GDK.readyCb') {
    document.addEventListener('keydown', (event) => {
      let validOptionPressed = true;
      if (event.key === '+') {
        _timeScale += 0.1;
      } else if (event.key === '-') {
        _timeScale -= 0.1;
      } else if (event.key === '*') {
        _timeScale *= 2;
      } else if (event.key === '/') {
        _timeScale /= 2;
      } else if (event.key === '0') {
        _timeScale = 0;
      } else if (event.key === '1') {
        _timeScale = 1;
      } else if (event.key === '2') {
        _timeScale = 2;
      } else if (event.key === '3') {
        _timeScale = 3;
      } else if (event.key === '4') {
        _timeScale = 4;
      } else if (event.key === '5') {
        _timeScale = 5;
      } else if (event.key === '6') {
        _timeScale = 6;
      } else if (event.key === '7') {
        _timeScale = 7;
      } else if (event.key === '8') {
        _timeScale = 8;
      } else if (event.key === '9') {
        _timeScale = 9;
      } else {
        validOptionPressed = false;
      }

      if (validOptionPressed) {
        if (_timeScale > 256) _timeScale = 256;
        if (_timeScale < 0) _timeScale = 0;

        setSpeed(_timeScale);
      }
    });
  }
};

function setSpeed(speed) {
  // not sure this is needed here!
  // if (Reflex.gamePaused || Reflex.platformPaused) {
  //   soundManager.pauseAllSounds();
  // } else {
  //   soundManager.resumeAllSounds();
  // }
  soundManager.setTimeScale(speed);
  gsap.globalTimeline.timeScale(speed);
  Reflex.setGameSpeed(speed);
}

game.backFromReplay = function (data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.post('sounds:restorePreviouslyPlayingAudio', {
      reason: 'back from replay',
    });
  }
};

gameData.convertStringToSegmentId = function (str) {
  switch (str) {
    case 'segmentGreen': {
      return gameData.segmentDollar;
    }
    case 'segmentYellow': {
      return gameData.segmentBigWin;
    }
    case 'segmentBlue': {
      return gameData.segmentBonus;
    }
    case 'segmentRed': {
      return gameData.segmentFreespins;
    }
    case 'fsSegmentMega': {
      return gameData.fsSegmentMega;
    }
    case 'fsSegmentSuper': {
      return gameData.fsSegmentSuper;
    }
    case 'fsSegmentMidi': {
      return gameData.fsSegmentMidi;
    }
    case 'fsSegmentMinor': {
      return gameData.fsSegmentMinor;
    }
    case 'fsSegmentMini': {
      return gameData.fsSegmentMini;
    }
    case 'fsSegment3Fs': {
      return gameData.fsSegment3Fs;
    }
    case 'fsSegment5Fs': {
      return gameData.fsSegment5Fs;
    }
    case 'fsSegment8Fs': {
      return gameData.fsSegment8Fs;
    }
    default: {
      console.log('');
    }
  }
};

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

game.updateSplashScreen = function () {
  if (_splashScreenMask) {
    if (systemData.isLandscape) {
      _splashScreenMask.scale.x = 1280;
      _splashScreenMask.scale.y = 720;
    } else {
      _splashScreenMask.scale.x = 720;
      _splashScreenMask.scale.y = 1280;
    }
  }
};

Reflex.enableDeveloperMode();
//Reflex.developerModeData.createTestLanguages = true;
//Reflex.developerModeData.highlightTranslatedText = true;

game.onCreditChanged = function (creditTask) {
  gameData.credit = creditTask.data.balance;

  let credit = creditTask.data.balance;
  if (
    gdk.serverParser._inReplayMode === true &&
    gdk.serverParser._endGame === true &&
    gdk.serverParser.prepaidResultBalance !== 0
  ) {
    credit = gdk.serverParser.prepaidResultBalance;
  }

  if (credit) {
    gameData.creditMeter.set(credit);
  }
};

function prepaidStakeChanged(stake) {
  gameData.stakeMeter.set(stake);
}

function promotionEnded() {
  gameData.slotConfig.promotionActive = false;
  const stakeController = resourceManager.getController('stakeController');
  const newStake = stakeController.getCurrentStake();
  gameData.stakeMeter.set(newStake);
}

game.createGameVersion = function () {
  var versionString =
    gameData.gameName +
    ' v' +
    gameData.gameVersionMajor +
    '.' +
    +gameData.gameVersionMinor +
    '.' +
    gameData.gameVersionBugFix;
  console.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;
  gameData.stakes = [];

  for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
    gameData.stakes.push(gameConfigTask.data.slotConfig.coinSizes[i] * gameConfigTask.data.slotConfig.defaultNumLines);
  }
  gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
    gameConfigTask.data.slotConfig.defaultAmountPerLine
  );

  // Set initial state
  resourceManager.getController('inputOverlord').setState('enabled');

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer('gameContainer').visible = false;
  resourceManager.getContainer('DemoContainer').visible = false;
  resourceManager.getContainer('gameButtonContainer').visible = false;
  gameData.winningsText = resourceManager.get('winningsText');

  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;

  gameData.creditMeter = resourceManager.get('creditContainer:creditMeter');
  gameData.winningsMeter = resourceManager.get('winningsContainer:winningsMeter');
  gameData.stakeMeter = resourceManager.get('betContainer:BetMeter');

  messageBus.subscribe('common:BalanceEvent', game.onCreditChanged);
  messageBus.subscribe('prepaid:StakeChange', prepaidStakeChanged);
  messageBus.subscribe('common:PromotionEnded', promotionEnded);
  messageBus.subscribe('game:modal', game.modal);
  messageBus.subscribe('game:sideMenuOpen', game.sideMenuOpenMsg);
  messageBus.subscribe('game:sideMenuClosed', game.sideMenuClosedMsg);
  messageBus.subscribe('game:backFromReplay', game.backFromReplay);
  messageBus.subscribe('game:skipSplash', game.skipSplash);

  Reflex.registerEventHandler('orientationChange', game.onOrientationChange);
  Reflex.registerEventHandler('resize', game.onResize);

  gameController.initialise(gameConfigTask);

  // Kick off the game
  game.onResize();

  game.onOrientationChange();

  gameController.start();
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }

  if (game.splashScreenDone) {
    switch (layoutController.getCurrentLayout()) {
      case 'landscape_default':
      case 'landscape_mobile': {
        resourceManager.getContainer('backgroundContainer').visible = true;
        resourceManager.getContainer('backgroundContainerPortrait').visible = false;
        break;
      }
      case 'portrait_default':
      case 'portrait_mobile': {
        resourceManager.getContainer('backgroundContainer').visible = false;
        resourceManager.getContainer('backgroundContainerPortrait').visible = true;
        break;
      }
    }
  }
};

game.onCloseTutorial = function () {
  if (!_gameAlreadyLoaded) {
    const bgContainer = resourceManager.getContainer('backgroundContainer');
    bgContainer.visible = true;
    gameData.gameMask = new PIXI.Graphics();
    gameData.gameMask.beginFill(0xffffff);
    gameData.gameMask.lineStyle(0, 0xffffff);
    gameData.gameMask.drawRect(0, 0, 1, 1);
    bgContainer.addChild(gameData.gameMask);

    systemData.gameContainer.mask = gameData.gameMask;

    _backgroundLightning = resourceManager.get('slotContainer:backgroundLightningDisplay:backgroundLightningDisplay');
    _backgroundLightning.startBackground();
    gameController.playLogoAnim();

    game.onResize();
    _gameAlreadyLoaded = true;
  }
};

game.disableSplashBackgrounds = function (background, portrait_background) {
  background.visible = false;
  background.interactive = false;
  background.on('mouseup', function () {});
  background.on('touchend', function () {});
  portrait_background.visible = false;
  portrait_background.interactive = false;
  portrait_background.on('mouseup', function () {});
  portrait_background.on('touchend', function () {});
};

game.skipSplash = function () {
  let license;

  resourceManager.getContainer('splashBackgroundContainer').visible = false;

  if (gameData.license === '' || gameData.license === undefined) {
    gameData.license === 'default';
  }

  license = gameData.license.toUpperCase();

  if (license === 'BR') {
    return;
  }
  game.goToGame();
};

game.goToSplash = function () {
  if (!game.splashScreenDone) {
    game.splashScreenDone = true;

    resourceManager.getContainer('splashBackgroundContainer').visible = true;
    resourceManager.getContainer('splashBackgroundContainerPortrait').visible = true;
    resourceManager.getContainer('loadingbackgroundContainer').visible = false;
    resourceManager.getContainer('loadingbackgroundContainerPortrait').visible = false;
    resourceManager.getContainer('helpPageScrollContainer').visible = true;
    resourceManager.getContainer('splashContainer').visible = true;

    gameData.helpPageScroll = resourceManager.get('helpPageScroll');

    let background = resourceManager.get('splashBg');
    let portrait_background = resourceManager.get('splashBgPortrait');
    background.on('mouseup', function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    background.on('touchend', function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });

    portrait_background.on('mouseup', function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    portrait_background.on('touchend', function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    // No need to wait for a click if this is replay mode
    // if (gdk.serverParser._inReplayMode) {
    //   game.disableSplashBackgrounds(background, portrait_background);
    //   game.goToGame();
    //   return;
    // }
    if (!gdk.getPlatformAllowsSplashScreen()) {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    } else {
      // Initialise the revolving splash screen panel system
      initSplashScreen();

      game.autoClickForReplayRewatch(() => {
        game.disableSplashBackgrounds(background, portrait_background);
        game.goToGame();
      });
    }
  }
};

game.checkShouldShowPaytableAfterSplash = function () {
  if (gameData.license === '' || gameData.license === undefined) {
    gameData.license = 'default';
  }

  let license = gameData.license.toUpperCase();

  if (license === 'BR' && gameData.recoveryStake === undefined) {
    return true;
  }
  return false;
};

game.goToGame = function () {
  game.stopAutoClickForReplayRewatch();

  // Disable the splash screen panel system
  disableSplashScreen();

  if (gameData.recoveryStake) {
    gameController.onStakeChanged(gameData.recoveryStake);
  }

  if (gameData.license === '' || gameData.license === undefined) {
    gameData.license = 'default';
  }
  let license = gameData.license.toUpperCase();
  if (license !== 'BR') {
    gdk.loadingClosed();
  }

  if (bowser.chrome && bowser.android) {
    var chromeVersion = Number(String(bowser.version).substring(0, String(bowser.version).indexOf('.')));
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }
  game.slideShowActive = false;
  timerManager.stop(game.slideshowTimer);
  soundManager.stop('splash_screen');

  musicManager.onGameLoaded();
  gameController.setLogoIdle(true);

  // soundManager.play('welcome');
  resourceManager.getContainer('splashBackgroundContainer').visible = false;
  resourceManager.getContainer('splashBackgroundContainerPortrait').visible = false;
  resourceManager.getContainer('splashContainer').visible = false;
  resourceManager.getContainer('gameContainer').visible = true;
  resourceManager.getContainer('DemoContainer').visible = true;
  resourceManager.getContainer('gameButtonContainer').visible = true;
  resourceManager.getContainer('stakeSelectionContainer').visible = true;
  resourceManager.getContainer('backgroundContainer').visible = true;
  resourceManager.getContainer('backgroundContainerPortrait').visible = true;
  resourceManager.getContainer('PopupMaskContainer').visible = true;
  resourceManager.getContainer('mobileMeterPanel').visible = true;
  resourceManager.getContainer('featureUIContainer').visible = true;
  resourceManager.getContainer('popupContainer').visible = true;

  game.onOrientationChange();

  game.overrideButtons();
  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  if (gameController.gameRecovering) {
    gameController.initNewGame();
  }

  gameController.titleSheenOn = true;
};

game.overrideButtons = function () {
  const uiName = 'uiContainer:bg';

  const slamStopButton = resourceManager.get(uiName + ':slamStopButton');
  slamStopButton.canEnableBase = slamStopButton.canEnable;
  slamStopButton.canEnable = function () {
    return (
      slamStopButton.canEnableBase() &&
      !gameController.spinComplete &&
      gameData.reelsSpinning > 0 &&
      gameController.canSlamStop
    );
  };
  const slamStopButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:slamStopButton_portrait');
  slamStopButtonPortrait.canEnableBase = slamStopButtonPortrait.canEnable;
  slamStopButtonPortrait.canEnable = function () {
    return (
      slamStopButtonPortrait.canEnableBase() &&
      !gameController.spinComplete &&
      gameData.reelsSpinning > 0 &&
      gameController.canSlamStop
    );
  };

  const autoplayController = resourceManager.getController('autoplayController');

  const baseStart = autoplayController.start;
  const baseCancel = autoplayController.cancel;

  autoplayController.start = function () {
    soundManager.play('buttonPressed');
    baseStart();
  };

  autoplayController.cancel = function () {
    if (game.autoplayPopupOpen) {
      soundManager.play('buttonPressed');
    }
    baseCancel();
  };

  const spinButton = resourceManager.get('uiContainer:bg:spinButton');
  spinButton.canEnableBase = spinButton.canEnable;
  spinButton.canEnable = function () {
    return (
      this.canEnableBase() && !gdk.serverParser._inReplayMode && !game.sideMenuOpen && !buyBonusPopup.container.visible
    );
  };
  spinButton.canShowBase = spinButton.canShow;
  spinButton.canShow = function () {
    return this.canShowBase() && !gameController.isAnimatingWins();
  };

  const spinButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:spinButton_portrait');
  spinButtonPortrait.canEnableBase = spinButtonPortrait.canEnable;
  spinButtonPortrait.canEnable = function () {
    return (
      this.canEnableBase() && !gdk.serverParser._inReplayMode && !game.sideMenuOpen && !buyBonusPopup.container.visible
    );
  };
  spinButtonPortrait.canShowBase = spinButton.canEnable;
  spinButtonPortrait.canShow = function () {
    return this.canShowBase() && !gameController.isAnimatingWins();
  };

  const autoplayButton = resourceManager.get('uiContainer:bg:autoplayButton');
  autoplayButton.baseCanEnable = autoplayButton.canEnable;
  autoplayButton.canEnable = function () {
    return this.baseCanEnable() && !gdk.serverParser._inReplayMode && !game.sideMenuOpen;
  };
  const autoplayButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:autoplayButton_portrait');
  autoplayButtonPortrait.baseCanEnable = autoplayButtonPortrait.canEnable;
  autoplayButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen && !gdk.serverParser._inReplayMode;
  };

  const stakeButton = resourceManager.get('uiContainer:bg:stake');
  stakeButton.baseCanEnable = stakeButton.canEnable;
  stakeButton.canEnable = function () {
    if (!this._flags.modal.active) {
      let popUpsOpen = false;
      let autoplay = resourceManager.get('autoplayContainer:autoplayBacker');
      if (autoplay.visible) popUpsOpen = true;

      let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
      if (buyBonusPopUp.visible) popUpsOpen = true;

      if (popUpsOpen) messageBus.post('game:modal', { reason: 'popups are open' });
    }
    return this.baseCanEnable() && !game.sideMenuOpen && !gdk.serverParser._inReplayMode;
  };

  const stakeButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:stake_portrait');
  stakeButtonPortrait.baseCanEnable = stakeButtonPortrait.canEnable;
  stakeButtonPortrait.canEnable = function () {
    if (!this._flags.modal.active) {
      let popUpsOpen = false;
      let autoplay = resourceManager.get('autoplayContainer:autoplayBacker');
      if (autoplay.visible) popUpsOpen = true;

      let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
      if (buyBonusPopUp.visible) popUpsOpen = true;

      if (popUpsOpen) messageBus.post('game:modal', { reason: 'popups are open' });
    }
    return this.baseCanEnable() && !game.sideMenuOpen && !gdk.serverParser._inReplayMode;
  };

  const volumeButton = resourceManager.get('uiContainer:bg:volume');
  volumeButton.baseCanEnable = volumeButton.canEnable;
  volumeButton.canEnable = function () {
    if (!this._flags.modal.active) {
      let popUpsOpen = false;
      let autoplay = resourceManager.get('autoplayContainer:autoplayBacker');
      if (autoplay.visible) popUpsOpen = true;

      let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
      if (buyBonusPopUp.visible) popUpsOpen = true;

      if (popUpsOpen) messageBus.post('game:modal', { reason: 'popups are open' });
    }
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const sideMenuBtn = resourceManager.get('uiContainer:bg:sideMenu');
  sideMenuBtn.baseCanEnable = sideMenuBtn.canEnable;
  sideMenuBtn.canEnable = function () {
    if (!this._flags.modal.active) {
      let popUpsOpen = false;
      let autoplay = resourceManager.get('autoplayContainer:autoplayBacker');
      if (autoplay.visible) popUpsOpen = true;

      let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
      if (buyBonusPopUp.visible) popUpsOpen = true;

      if (popUpsOpen) messageBus.post('game:modal', { reason: 'popups are open' });
    }
    return this.baseCanEnable() && !game.sideMenuOpen && !gdk.serverParser._inReplayMode;
  };

  const sideMenuBtnPort = resourceManager.get('buttonContainerMobile:reflexButtonBar:sideMenu_portrait');
  sideMenuBtnPort.baseCanEnable = sideMenuBtnPort.canEnable;
  sideMenuBtnPort.canEnable = function () {
    if (!this._flags.modal.active) {
      let popUpsOpen = false;
      let autoplay = resourceManager.get('autoplayContainer:autoplayBacker');
      if (autoplay.visible) popUpsOpen = true;

      let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
      if (buyBonusPopUp.visible) popUpsOpen = true;

      if (popUpsOpen) messageBus.post('game:modal', { reason: 'popups are open' });
    }
    return this.baseCanEnable() && !game.sideMenuOpen && !gdk.serverParser._inReplayMode;
  };
};

game.modal = function (task) {
  if (task.reason === 'autoplay') {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === '') {
    game.autoplayPopupOpen = false;
  }
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {
  helpPageManager.showPopup(game.onHelpPagesClosed);
};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.autoClickForReplayRewatch = function (cb, time = 4000) {
  if (gdk.serverParser._inReplayMode || gdk.serverParser._inRewatchMode) {
    game.stopAutoClickForReplayRewatch(); // just in case
    game._autoClickForReplayRewatchTimer = timerManager.addTimeout(time, cb);
  }
};

game.stopAutoClickForReplayRewatch = function () {
  if (game._autoClickForReplayRewatchTimer) {
    timerManager.stop(game._autoClickForReplayRewatchTimer);
    game._autoClickForReplayRewatchTimer = undefined;
  }
};

// Splash screen panel system functions

async function tweenFromToAsync(targets, fromVars, toVars, tweenInfo = null) {
  let resolver = null;
  const tweenPromise = new Promise((resolve) => {
    resolver = resolve;
  });

  const origOnComplete = toVars.onComplete;
  toVars.paused = true;
  toVars.onComplete = () => {
    if (origOnComplete) {
      origOnComplete();
    }
    resolver();
  };

  const tween = gsap.fromTo(targets, fromVars, toVars);
  tween.time(0).restart(true);

  if (tweenInfo) {
    tweenInfo.tween = tween;
    tweenInfo.resolver = resolver;
    tweenInfo.promise = tweenPromise;
  }

  return tweenPromise;
}

function initSplashScreen() {
  game.slideShowActive = true;
  grabSplashScreenComponents();
  setupMaskForSplashScreen();
  initSplashScreenArrowButtons();
  showCurrentSplashScreenPanel();

  // Auto-rotation timeline: rotates every 5 seconds
  _splashScreenAutoSwapPanelTimeline = gsap.timeline({ repeat: -1 }).call(
    () => {
      swapSplashScreenPanel(1);
    },
    undefined,
    '<+=5'
  );
}

function setupMaskForSplashScreen() {
  _splashScreenMask = new PIXI.Graphics();
  _splashScreenMask.beginFill(0xffffff);
  _splashScreenMask.drawRect(0, 0, 1, 1);

  const splashContainer = resourceManager.getContainer('splashContainer');
  splashContainer.addChild(_splashScreenMask);
  splashContainer.mask = _splashScreenMask;

  if (_splashScreenMask) {
    if (systemData.isLandscape) {
      _splashScreenMask.scale.x = 1280;
      _splashScreenMask.scale.y = 720;
    } else {
      _splashScreenMask.scale.x = 720;
      _splashScreenMask.scale.y = 1280;
    }
  }
}

function grabSplashScreenComponents() {
  _splashScreenArrowLeft = resourceManager.get('splashButtonsContainer:arrowLeft');
  _splashScreenArrowRight = resourceManager.get('splashButtonsContainer:arrowRight');

  for (let i = 0; i < 3; i++) {
    if (i === 2) {
      // Page 2 is currently golden bet panel
      if (gdk.getServerParser().isUpstakeAllowed()) {
        _splashScreenPanelContents[i] = resourceManager.get(
          `splashPanelContainer:splashPanelContents:splashPanelContent${i}`
        );
      }
    } else {
      _splashScreenPanelContents[i] = resourceManager.get(
        `splashPanelContainer:splashPanelContents:splashPanelContent${i}`
      );
    }
  }

  // Define custom polygon hit areas for better click detection
  const leftPolygon = [50, -140, 10, -140, -48, 0, 10, 140, 50, 140];
  _splashScreenArrowLeft.hitArea = new PIXI.Polygon(leftPolygon);
  const rightPolygon = [-50, -140, -10, -140, 48, 0, -10, 140, -50, 140];
  _splashScreenArrowRight.hitArea = new PIXI.Polygon(rightPolygon);
}

async function swapSplashScreenPanel(direction) {
  if (_splashScreenPanelSwapping) return;

  _splashScreenPanelSwapping = true;

  // Visual feedback: dim the arrow that was clicked
  if (direction === -1) {
    _splashScreenArrowLeft.alpha = 0.7;
  } else {
    _splashScreenArrowRight.alpha = 0.7;
  }

  const currentIndex = _currentSplashScreenPanelIndex;
  let nextIndex = _currentSplashScreenPanelIndex + direction;

  // Wrap around: create circular navigation
  if (nextIndex < 0) {
    nextIndex = _splashScreenPanelContents.length - 1;
  } else if (nextIndex > _splashScreenPanelContents.length - 1) {
    nextIndex = 0;
  }

  // Setup new panel for fade in
  _splashScreenPanelContents[nextIndex].visible = true;
  _splashScreenPanelContents[nextIndex].alpha = 0;

  // Animate both panels simultaneously
  await Promise.all([
    tweenFromToAsync(_splashScreenPanelContents[currentIndex], { alpha: 1 }, { alpha: 0, duration: 0.25 }),
    tweenFromToAsync(_splashScreenPanelContents[nextIndex], { alpha: 0 }, { alpha: 1, duration: 0.25 }),
  ]);

  // Cleanup: hide current panel and restore arrow opacity
  _splashScreenPanelContents[currentIndex].visible = false;
  _splashScreenPanelContents[currentIndex].alpha = 0;

  _splashScreenArrowLeft.alpha = 1;
  _splashScreenArrowRight.alpha = 1;

  _currentSplashScreenPanelIndex = nextIndex;
  _splashScreenPanelSwapping = false;
}

function showCurrentSplashScreenPanel() {
  for (let i = 0; i < _splashScreenPanelContents.length; i++) {
    _splashScreenPanelContents[i].visible = false;
    _splashScreenPanelContents[i].alpha = 0;
  }

  _splashScreenPanelContents[_currentSplashScreenPanelIndex].visible = true;
  _splashScreenPanelContents[_currentSplashScreenPanelIndex].alpha = 1;
}

function disableSplashScreen() {
  if (_splashScreenAutoSwapPanelTimeline) {
    _splashScreenAutoSwapPanelTimeline.pause();
  }
  disableSplashScreenArrowButtons();
  const splashContainer = resourceManager.getContainer('splashContainer');
  if (_splashScreenMask) {
    splashContainer.removeChild(_splashScreenMask);
    splashContainer.mask = null;
    _splashScreenMask = null;
  }
}

function disableSplashScreenArrowButtons() {
  if (_splashScreenArrowLeft) {
    _splashScreenArrowLeft.interactive = false;
  }
  if (_splashScreenArrowRight) {
    _splashScreenArrowRight.interactive = false;
  }
}

function initSplashScreenArrowButtons() {
  _splashScreenArrowLeft.interactive = true;
  _splashScreenArrowRight.interactive = true;

  _splashScreenArrowLeft.on('mouseup', function () {
    swapSplashScreenPanel(-1);
    _splashScreenAutoSwapPanelTimeline.pause();
    return;
  });
  _splashScreenArrowLeft.on('touchend', function () {
    swapSplashScreenPanel(-1);
    _splashScreenAutoSwapPanelTimeline.pause();
    return;
  });

  _splashScreenArrowRight.on('mouseup', function () {
    swapSplashScreenPanel(1);
    _splashScreenAutoSwapPanelTimeline.pause();
    return;
  });
  _splashScreenArrowRight.on('touchend', function () {
    swapSplashScreenPanel(1);
    _splashScreenAutoSwapPanelTimeline.pause();
    return;
  });
}
